export const documentTypeFeatureKey = 'documentType';

export type DocumentTypeModel = {
  id: number;
  name: string;
  description: string;
};

export type DocumentTypeExtendedModel = DocumentTypeModel & {
  mandatory?: boolean;
};
